import { useTranslation } from "react-i18next";
import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarTrigger,
} from "@/components/ui/menubar";
import { Send, User } from "lucide-react";
import ConfirmDialog from "@/components/confirm-dialog";

interface ContestAgreementMenuProps {
  id: string;
  isResendPending: boolean;
  canSendAgreement2: boolean;
  onResendLink: () => void;
  onGoToContractor: () => void;
}

export const ContestAgreementMenu = ({
  id,
  isResendPending,
  canSendAgreement2,
  onResendLink,
  onGoToContractor,
}: ContestAgreementMenuProps) => {
  const { t } = useTranslation();

  return (
    <Menubar className="mb-2">
      <MenubarMenu>
        <MenubarTrigger>
          {t("contestAgreements.detail.menubar.trigger")}
        </MenubarTrigger>
        <MenubarContent>
          {canSendAgreement2 && (
            <ConfirmDialog
              title={t("contestAgreements.detail.resendLinkConfirm.title")}
              content={t(
                "contestAgreements.detail.resendLinkConfirm.description",
              )}
              yesLabel={t("contestAgreements.detail.resendLinkButton")}
              noLabel={t("common.cancel")}
              onConfirm={onResendLink}
            >
              <MenubarItem
                onSelect={(e) => e.preventDefault()}
                disabled={isResendPending}
              >
                <Send className="mr-2 h-4 w-4" />
                {t("contestAgreements.detail.resendLinkButton")}
              </MenubarItem>
            </ConfirmDialog>
          )}
          <MenubarItem onClick={onGoToContractor}>
            <User className="mr-2 h-4 w-4" />
            {t("contestAgreements.detail.menubar.goToContractor")}
          </MenubarItem>
        </MenubarContent>
      </MenubarMenu>
    </Menubar>
  );
};
